// 30 Day Usage Summary
export const THIRTY_DAY_REPORT_ID = "ceddeafb-7b58-4a28-bec4-7fcacb98c27f";
export const THIRTY_DAY_REPORT_WORKSPACE_ID = "c9679fac-e043-4b12-b47b-d350f81543c1"
export const THIRTY_DAY_TITLE = "30 Day Usage Stats";

// 90 Day Dashboard Summary
export const NINETY_DAY_DASHBOARD_REPORT_ID = "750eda9a-3053-41ae-a21c-241908960d1c";
export const NINETY_DAY_DASHBOARD_REPORT_WORKSPACE_ID = "c9679fac-e043-4b12-b47b-d350f81543c1";
export const NINETY_DAY_DASHBOARD_TITLE = "90 Day Dashboard";

// 90 Day User Summary
export const NINETY_DAY_USER_REPORT_ID = "e1daf043-b34b-4e07-b03f-53b69d383840";
export const NINETY_DAY_USER_REPORT_WORKSPACE_ID = "c9679fac-e043-4b12-b47b-d350f81543c1";
export const NINETY_DAY_USER_TITLE = "90 Day User";

// 90 Day Consumption Summary
export const NINETY_DAY_CONSUMPTION_REPORT_ID = "7c532d84-a8fe-486b-953e-973cbb22c422";
export const NINETY_DAY_CONSUMPTION_REPORT_WORKSPACE_ID = "c9679fac-e043-4b12-b47b-d350f81543c1";
export const NINETY_DAY_CONSUMPTION_TITLE = "90 Day Consumption";